import Axios from 'axios';
import Qs from 'qs';

export default {

  // 访客分页列表
  listPage(
    community_id,
    visitor_name,
    resident_name,
    visit_purpose,
    page,
    limit
  ) {
    return Axios.get('/visit/api/admin/visit', {
      params: {
        filter: {
          visitor_name,
          resident_name,
          visit_purpose
        },
        sort: {
          id: 'desc'
        },
        community_id,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 访客信息
  info(
    id
  ) {
    return Axios.get(`/visit/api/admin/visit/${id}`);
  },

}